import React, { useState } from 'react'
import { useTranslation } from "react-i18next";

const NewInputGenericPassword = ({
  handleChange,
  values,
  errors,
  placeholderVal,
  field,
  max_length,
  moduleText,
  occupation = 6,
  css_class,
  setValues
}) => {

  const { t } = useTranslation();
  const [radio, setRadio] = useState("no");

  const handleChangeRadioButton = (event) => {

    const radioValue = event.target.value;

    if (radioValue === "yes") {

       setValues((values) => ({ ...values, [field]: "" }));
       setValues((values) => ({ ...values, "isChangedPassword": true }));

      setRadio(radioValue);
      
    } else if (radioValue === "no") {

       setValues((values) => ({ ...values, "isChangedPassword": false }));

      const valuesModify = { ...values };
      if (valuesModify.hasOwnProperty([field])) {
        delete valuesModify[field];
        
        setValues(valuesModify);
      }

      setRadio(radioValue);
    }

  }

  return (
    <div className={`col-md-${occupation}`}>
      <>
        <label htmlFor="radioB" className="form-label tit-view">
          {t(`${moduleText}.short.change-password`)}
        </label>
        <div className="control">
          <div onChange={(event) => handleChangeRadioButton(event)}>
            <input readOnly type="radio" value="yes" name="radioB" checked={radio === "yes"} /> Si
            <input readOnly type="radio" value="no" name="radioB" checked={radio === "no"} /> No
          </div>
        </div>
      </>
      {radio === "yes" && (
        <>
          <label htmlFor={field} className="form-label tit-view">
            {t(`${moduleText}.short.${field}`)}
          </label>
          <div className="control">
            <input
              autoComplete="off"
              
              className={`form-control txt-view ${errors[field] && "border border-danger"}`}
              type="text"
              name={field}
              id={field}
              onChange={(event) => handleChange(event, field)}
              value={values[field] || ""}
              required
              maxLength={max_length}
              placeholder={placeholderVal ? t(`${moduleText}.short.${field}`) : null}
            />
            {values[field] && (
              <span className="charLeft">
                {values[field].length}/{max_length} {t("label.characters")}
              </span>
            )}
            {errors[field] && <pre><pre> <p className="help text-danger">{errors[field]}</p> </pre></pre>}
          </div>
        </>
      )}
    </div>

  )
}

export default NewInputGenericPassword

